import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import DOMPurify from 'dompurify';
import { logger } from '../../utils/logger';
import { useI18n } from '../../i18n/useI18n';
import './TermsModal.css';

interface TermsModalProps {
  visible: boolean;
  type: 'terms' | 'privacy';
  onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({ visible, type, onClose }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useI18n();

  useEffect(() => {
    if (visible) {
      setLoading(true);
      const url = type === 'terms' ? '/terms.html' : '/privacy.html';
      
      fetch(url)
        .then(response => response.text())
        .then(html => {
          // 提取 body 中的内容，移除不需要的元素
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const container = doc.querySelector('.container');
          if (container) {
            // 移除返回链接
            const backLink = container.querySelector('.back-link');
            if (backLink) {
              backLink.remove();
            }
            setContent(container.innerHTML);
          } else {
            // 如果没有找到 .container，使用 body 内容
            const bodyContent = doc.body.innerHTML;
            setContent(bodyContent);
          }
        })
        .catch(error => {
          logger.error('加载内容失败:', error);
          setContent(`<p>${t('auth.loadFailed')}</p>`);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [visible, type, t]);

  const title = type === 'terms' ? t('auth.terms') : t('auth.privacy');

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      className="terms-modal"
      styles={{
        body: {
          maxHeight: '70vh',
          overflowY: 'auto',
          padding: '24px',
        }
      }}
    >
      {loading ? (
        <div className="terms-loading">{t('auth.loading')}</div>
      ) : (
        <div 
          className="terms-content"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        />
      )}
    </Modal>
  );
};

